module.exports = __webpack_public_path__ + "img/wash.083a3961.svg";